module.exports = __webpack_public_path__ + "static/img/icon_cloud_item2.2386432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_item2.jpg
// module id = s/Ic
// module chunks = 21